import { z } from 'zod';
/**
 * How RecruitCRM fails. Read a response body as TEXT first and parse JSON only when it parses:
 * several of these are not JSON (Relay nitpick 2026-07-17, a `res.json()` on `BAD_AUTHOR…`
 * crashed a proxy).
 */
/**
 * The error envelope: `{"error":true,"errorCode":422,"errorMessage":"…"}`. `errorCode` is a
 * NUMBER on the observed no-change 422 and the STRING `"404"` on the documented not-found.
 */
export const rcrmErrorBodySchema = z.looseObject({
    error: z.boolean(),
    errorCode: z.union([z.number(), z.string()]),
    errorMessage: z.string(),
});
/** Laravel validation: `{"description":["The description may not be greater than 10000 characters."]}`. */
export const rcrmValidationErrorBodySchema = z.record(z.string(), z.array(z.string()));
/**
 * 422 on an update that changes nothing (`Relay/.test/under_resp.txt`). The sync treats it as a
 * successful no-op (TS-1831 decision 16).
 */
export const RCRM_NO_CHANGE_MESSAGE = 'At least one value must change!';
/** A note's `description` above this many characters is refused with 422 (`Relay/.test/over_resp.txt`). */
export const RCRM_NOTE_MAX_CHARS = 10_000;
export const RCRM_NOTE_TOO_LONG_MESSAGE = `The description may not be greater than ${RCRM_NOTE_MAX_CHARS} characters.`;
/**
 * A missing or empty bearer token is answered 422 with a PLAIN TEXT body starting with this
 * prefix (Relay nitpick 2026-07-17; only the prefix was captured, the rest of the text is not
 * known — `BAD_AUTHORIZATION_HEADER` is that nitpick's guess).
 */
export const RCRM_BAD_AUTH_PREFIX = 'BAD_AUTHOR';
/**
 * Rate-limit headers (official docs), lower-cased as `Headers` returns them. The 429 BODY is
 * undocumented: a client decides on the status and these headers only.
 */
export const RCRM_RATE_LIMIT_HEADERS = {
    limit: 'x-ratelimit-limit',
    remaining: 'x-ratelimit-remaining',
};
/** True for the no-change 422 body, parsed or raw. */
export function isRcrmNoChange(body) {
    const parsed = rcrmErrorBodySchema.safeParse(body);
    return parsed.success && parsed.data.errorMessage === RCRM_NO_CHANGE_MESSAGE;
}
/** True for the plain-text authorization rejection. */
export function isRcrmBadAuth(text) {
    return text.trimStart().startsWith(RCRM_BAD_AUTH_PREFIX);
}
//# sourceMappingURL=errors.js.map